import React, { useEffect, useContext, useState, useMemo } from 'react';
import Button from '../../../../components/UI/Button';
import InteractiveText from '../UI/InteractiveText';
import TaskList from '../UI/TaskList';
import css from './begin_application.module.scss';
import { useCreditClient } from '../../../../services/credit';
import { getPlanNameText } from '../helpers';
import { AnalyticsContext } from '../../../../ModularReduxAnalytics';

export const ACCOUNT_CREATED_MESSAGE =
  'Your Greenlight account has been created!';

export default function BeginApplication({
  updateCreditApplication,
  planName,
  authToken,
  moveToFundWallet
}) {
  const creditApplicationClient = useMemo(() => useCreditClient(), []);
  const [skipFCC, setSkipFCC] = useState<boolean>(false);
  const { analytics } = useContext(AnalyticsContext);

  useEffect(() => {
    window.scrollTo(0, 0);
    analytics.page('Registration', 'FCC Application Account Created');
  }, []);

  const startCreditApplication = async () => {
    analytics.trackEvent('Credit Action', {
      eventProps: {
        type: 'Apply',
        page: 'FCC Application Account Created'
      }
    });

    const startCreditApplicationResult =
      await creditApplicationClient.startCreditApplication({
        authToken
      });

    updateCreditApplication(startCreditApplicationResult);
  };

  const tasks = [
    { completed: true, text: 'Create a Greenlight account' },
    { completed: false, text: 'Apply for the Family Cash Card' },
    { completed: false, text: 'Link your payment account' }
  ];

  const planNameText = getPlanNameText(planName);

  const heading = skipFCC
    ? `Continue with ${planNameText}.`
    : ACCOUNT_CREATED_MESSAGE;

  const subText = skipFCC
    ? `You still have a 1-month free trial of ${planNameText}. This plan includes an educational app with debit cards for your kids to send them money, set up chores, and more.`
    : `Just a few more steps to apply for the Family Cash Card and start using your ${planNameText} plan:`;

  const buttonText = skipFCC ? 'Continue' : 'Apply for Family Cash Card';
  return (
    <div>
      <h1
        className={css.heading}
        data-testid={skipFCC ? 'continue-header' : 'account-created-header'}
      >
        {heading}
      </h1>
      <p className={css.subtext}>{subText}</p>
      {!skipFCC && <TaskList tasks={tasks} />}
      <Button
        onClick={skipFCC ? moveToFundWallet : startCreditApplication}
        text={buttonText}
      />
      {!skipFCC && (
        <InteractiveText
          text="Not now"
          handleClick={() => {
            analytics.trackEvent('Credit Action', {
              eventProps: {
                type: 'Not now',
                page: 'FCC Application Account Created'
              }
            });
            setSkipFCC(true);
          }}
        />
      )}
    </div>
  );
}
